// extracted by mini-css-extract-plugin
module.exports = {"imgBox":"mostOrdered_imgBox__1hDJw","description":"mostOrdered_description__3m-s8","price":"mostOrdered_price__3X6Td","tag":"mostOrdered_tag__2OVrc"};